// extracted by mini-css-extract-plugin
export default {"Settingcontainer":"Settings_Settingcontainer__P97hh","AddAdmin":"Settings_AddAdmin__R+Xi3"};